import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SidebarToggleProps {
  isCollapsed: boolean;
  onToggle: () => void;
  className?: string;
}

export const SidebarToggle = ({ isCollapsed, onToggle, className }: SidebarToggleProps) => {
  return (
    <button
      onClick={onToggle}
      className={cn(
        'absolute -right-3 top-20 bg-background border rounded-full p-1 shadow-sm hover:bg-accent z-50',
        className
      )}
      aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}>
      {isCollapsed ? <ChevronRight className="w-3 h-3" /> : <ChevronLeft className="w-3 h-3" />}
    </button>
  );
};
